import React from "react";

export const FilterIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({
    className = "w-6 h-6 text-gray-100",
    ...props
}) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" className={className} {...props}>
            <path d="M3 7H21" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
            <path d="M6 12H18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
            <path d="M10 17H14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
    );
};
